// Copyright (c) 2016 Deere & Company

import SearchByDropdown from '@deere/cps-it.warranty-model-factory/lib/search-by-dropdown';

export const getDefaultState = () =>
    new SearchByDropdown({
        searchBy: [
            {
                key: 'CLAIM',
                value: 'CLAIM'
            },
            {
                key: 'RGA_WORK_ORDER',
                value: 'WORK_ORDER'
            },
            {
                key: 'PIN',
                value: 'PIN'
            },
            {
                key: 'PART_REQUEST',
                value: 'PART_REQUEST'
            },
            {
                key: 'PART_NUMBER',
                value: 'PART_NUMBER'
            },
            {
                key: 'DTAC_CASE_NUMBER',
                value: 'DTAC_CASE_NUMBER'
            }
        ],
        selectedOption: {
            key: 'CLAIM',
            value: 'CLAIM'
        }
    });

export default SearchByDropdown;



// WEBPACK FOOTER //
// ./src/part-requests/search/state/search-by-dropdown.js